<span class="small ms-2"
      *ngIf="hasWatcher">Watching this</span>
<adapt-menu [items]="menuItems"
            [showOnHover]="true"
            orientation="vertical"></adapt-menu>
